import { IconName, MaybeElement } from '@blueprintjs/core';
import { classNames } from '../../utils/classNames';
import styles from './IconButton.module.css';
import { ButtonHTMLAttributes } from 'react';

export interface IIconButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconName | MaybeElement;
  size?: number;
  onClick?: React.MouseEventHandler;
  classes?: ClassNamesProp;
  children?: MaybeElement;
  iconPlacement?: IIconPlacement;
  title?: string;
  disabled?: boolean;
}

type ClassNamesProp = {
  root?: string;
  container?: string;
  icon?: string;
};

type IIconPlacement = 'left' | 'right' | 'centered';

function classForIconPlacement(iconPlacement?: IIconPlacement) {
  switch (iconPlacement) {
    case 'left':
      return styles.left;
    case 'right':
      return styles.right;
    default:
      return styles.centered;
  }
}

export function IconButton({
  icon,
  size = 16,
  onClick,
  classes,
  children,
  iconPlacement,
  title,
  disabled,
  ...props
}: IIconButton) {
  return (
    <button
      type={'button'}
      {...props}
      className={classNames(styles.iconButton, classes?.root ?? '')}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <div
        className={classNames(
          styles.container,
          classForIconPlacement(iconPlacement),
          classes?.container
        )}
      >
        {children && <div className={styles.content}>{children}</div>}
        <span
          className={classNames(
            `bp5-icon-large bp5-icon-${icon}`,
            classes?.icon ?? ''
          )}
          style={{ fontSize: size }}
        />
      </div>
    </button>
  );
}
